export const TEMPLATE_FORM_FIELD = {
  STEP_ONE_CATEGORY: 'stepOne.category',
  STEP_ONE_EQUITY_PLAN: 'stepOne.equityPlan',
  STEP_ONE_SUB_CATEGORY: 'stepOne.subCategory',
  STEP_THREE_FILE: 'stepThree.file',
  STEP_TWO_SIGNATORIES: 'stepTwo.signatories',
};

export type TemplateFormFieldPath = (typeof TEMPLATE_FORM_FIELD)[keyof typeof TEMPLATE_FORM_FIELD];
